import PropTypes from "prop-types";
import React, { Component } from "react";
import { Trans } from "@lingui/macro";
import { Dialog, Input, MenuItem, Select, withStyles } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import { getWeekDays } from "../utils/constants";
import { translator } from "../utils/i18n";
import { connect } from "react-redux";
import { setMessage } from "../actions";
import { DatePicker, TimePicker } from "@material-ui/pickers";
import SnoozeIcon from "@material-ui/icons/Snooze";
import AlarmIcon from "@material-ui/icons/AddAlarm";
import DateIcon from "@material-ui/icons/DateRange";
import { IconButton, InputAdornment } from "@material-ui/core";
import { DateTime } from "luxon";
import Checkbox from "@material-ui/core/Checkbox";
import CloseIcon from "@material-ui/icons/Close";

const styles = () => ({
  dialog: {
    borderRadius: "15px",
    maxWidth: "680px",
    width: "680px"
  }
});

class Notification extends Component {
  state = {
    open: true,
    heure_debut_avertir: null,
    heure_fin_avertir: null,
    fromDate: null,
    toDate: null,
    jours_avertir: Object.assign(
      {},
      ...Array.from(getWeekDays(), key => ({ [key.value]: false }))
    )
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.setMessage(null);
  };

  handleCancel = () => {
    if (this.props.setChecked) {
      this.props.setChecked(false);
    }
    this.handleClose();
  };

  buildSelect = (label, id, name, data) => {
    return (
      <div className="wrap-input mt-0">
        <Select
          name={name}
          input={<Input name={name} id={id} />}
          value={this.state[name]}
          onChange={this.onSelectChange}
          className="select"
          displayEmpty
        >
          <MenuItem value="">
            <Trans id={label} />
          </MenuItem>
          {data.map(item => {
            return (
              <MenuItem key={item.key || item.value} value={item.value}>
                {item.label}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  };

  onSelectChange = event => {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    let {
      fromDate,
      toDate,
      heure_debut_avertir,
      heure_fin_avertir,
      jours_avertir
    } = this.state;

    if (fromDate) {
      fromDate = fromDate.setLocale("fr").toLocaleString(DateTime.DATE_SHORT);
    } else {
      fromDate = "";
    }
    if (toDate) {
      toDate = toDate.setLocale("fr").toLocaleString(DateTime.DATE_SHORT);
    } else {
      toDate = this.props.infoRdv.date_fr;
    }

    if (heure_debut_avertir) {
      heure_debut_avertir = heure_debut_avertir
        .setLocale("fr")
        .toLocaleString(DateTime.TIME_24_SIMPLE);
    } else {
      heure_debut_avertir = "";
    }

    if (heure_fin_avertir) {
      heure_fin_avertir = heure_fin_avertir
        .setLocale("fr")
        .toLocaleString(DateTime.TIME_24_SIMPLE);
    } else {
      heure_fin_avertir = "";
    }

    var joursToSend = "";
    if (jours_avertir) {
      for (var key in jours_avertir) {
        const value = jours_avertir[key];
        if (value) {
          joursToSend += key + ",";
        }
      }
    }

    this.props.setNotificationData({
      fromDate,
      toDate,
      heure_debut_avertir,
      heure_fin_avertir,
      jours_avertir: joursToSend
    });
    /*
    this.props.notificationAppointment({
      fromDate,
      toDate,
      heure_debut_avertir,
      heure_fin_avertir,
      jours_avertir:joursToSend
    });
    */
    this.handleClose();
  };

  handleChangeTimeFrom = time => {
    this.setState({ heure_debut_avertir: time });
  };

  handleChangeTimeTo = time => {
    this.setState({ heure_fin_avertir: time });
  };

  handleFromChange = selectedDate => {
    this.setState({ fromDate: selectedDate });
  };

  handleToChange = selectedDate => {
    this.setState({ toDate: selectedDate });
  };

  changeCheckbox = event => {
    var new_jours_avertir = this.state.jours_avertir;

    if (new_jours_avertir[event.target.name] !== event.target.checked) {
      new_jours_avertir[event.target.name] = event.target.checked;
      this.setState({ jours_avertir: new_jours_avertir });
    }
  };

  render() {
    const { classes } = this.props;
    const { jours_avertir } = this.state;
    const { infoRdv } = this.props;
    return (
      <Dialog
        aria-labelledby="search-dialog-title"
        open={this.state.open}
        onClose={this.handleCancel}
        classes={{
          paper: classes.dialog
        }}
      >
        <IconButton
          className="close-dialog"
          aria-label="close"
          onClick={this.handleCancel}
          style={{ color: "white", marginRight: "7px", padding: "0" }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle className="head-dialog" id="search-dialog-title">
          <div className="title-dialog">
            <i className="material-icons">warning</i>
          </div>
        </DialogTitle>

        <div className="body-dialog">
          {this.props.message && (
            <div className="alert">{this.props.message}</div>
          )}
          <form className="form-search notification" onSubmit={this.onSubmit}>
            <div className="primary align-center">
              <strong>
                {translator()
                  ._("W_STEP3_TITLE_PREF")
                  .toUpperCase()}
              </strong>
            </div>
            <div className="align-center">
              {translator()._("W_STEP3_SUB_TITLE_INFO")}
            </div>
            <strong className="primary line-form mt-20 mb-12">
              {translator()._("W_JOUR")} :
            </strong>
            <div className="line-checkbox list-checkbox">
              {getWeekDays().map(item => {
                return (
                  <div className="align-center" key={"checkbox-" + item.value}>
                    <div className="align-center">{item.label}</div>

                    <Checkbox
                      key={"checkbox-" + item.value}
                      checked={jours_avertir[item.value]}
                      tabIndex={-1}
                      disableRipple
                      name={"" + item.value}
                      onChange={this.changeCheckbox}
                    />
                  </div>
                );
              })}
            </div>
            <strong className="primary line-form mt-15 mb-12">
              {translator()._("W_DATE")} :
            </strong>
            <div className="line-form">
              <DatePicker
                disableToolbar
                id="date-debut"
                name="date_debut_avertir"
                label={translator()._(
                  "W_STEP3_AFFINER_VOTRE_RECHERCHE_A_PARTIR_DU"
                )}
                value={this.state.fromDate}
                minDate={DateTime.local()}
                maxDate={DateTime.fromSQL(infoRdv.date_prise_rendez_vous)}
                onChange={this.handleFromChange}
                className="input-date"
                autoOk
                inputVariant="outlined"
                format="dd/MM/yyyy"
                cancelLabel={<Trans id="W_ANNULER" />}
                okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
                invalidDateMessage={<Trans id="W_DATE_INVALID" />}
                minDateMessage={translator()._("W_MIN_DATE_ALERT")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <DateIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <DatePicker
                disableToolbar
                id="date-fin"
                name="date_fin_avertir"
                label={translator()._(
                  "W_STEP3_AFFINER_VOTRE_RECHERCHE_JUSQUAU"
                )}
                value={this.state.toDate}
                minDate={this.state.fromDate}
                maxDate={DateTime.fromSQL(infoRdv.date_prise_rendez_vous)}
                onChange={this.handleToChange}
                className="input-date"
                autoOk
                inputVariant="outlined"
                format={"dd/MM/yyyy"}
                cancelLabel={<Trans id="W_ANNULER" />}
                okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
                minDateMessage={translator()._("W_MIN_DATE_ALERT")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <DateIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <strong className="primary line-form mt-15 mb-12">
              {translator()._("W_HEURES")} :
            </strong>

            <div className="line-form">
              <TimePicker
                autoOk
                disableFuture
                hideTabs
                ampm={false}
                value={this.state.heure_debut_avertir}
                onChange={time => this.handleChangeTimeFrom(time)}
                leftArrowIcon={<AlarmIcon />}
                leftArrowButtonProps={{ "aria-label": "Prev month" }}
                rightArrowButtonProps={{ "aria-label": "Next month" }}
                rightArrowIcon={<SnoozeIcon />}
                name="heure_debut_avertir"
                inputVariant="outlined"
                label={translator()._(
                  "W_STEP3_AFFINER_VOTRE_RECHERCHE_A_PARTIR_DU"
                )}
                className="input-date"
                cancelLabel={<Trans id="W_ANNULER" />}
                okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <AlarmIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <TimePicker
                autoOk
                disableFuture
                hideTabs
                ampm={false}
                value={this.state.heure_fin_avertir}
                onChange={time => this.handleChangeTimeTo(time)}
                leftArrowIcon={<AlarmIcon />}
                leftArrowButtonProps={{ "aria-label": "Prev month" }}
                rightArrowButtonProps={{ "aria-label": "Next month" }}
                rightArrowIcon={<SnoozeIcon />}
                name="heure_fin_avertir"
                inputVariant="outlined"
                label={translator()._(
                  "W_STEP3_AFFINER_VOTRE_RECHERCHE_JUSQUAU"
                )}
                className="input-date"
                cancelLabel={<Trans id="W_ANNULER" />}
                okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <AlarmIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>

            <div className="wrap-btns mt-30">
              <button className="btn-default" type="submit">
                <Trans id="W_VALIDER" />
              </button>
            </div>
          </form>
        </div>
      </Dialog>
    );
  }
}

Notification.propTypes = {
  classes: PropTypes.shape({
    dialog: PropTypes.any
  }),
  infoRdv: PropTypes.shape({
    date_fr: PropTypes.any,
    date_prise_rendez_vous: PropTypes.any
  }),
  message: PropTypes.any,
  setChecked: PropTypes.func,
  setMessage: PropTypes.func,
  setNotificationData: PropTypes.func
};

const mapStateToProps = state => ({
  message: state.message
});

const mapDispatchToProps = dispatch => ({
  setMessage: message => dispatch(setMessage(message))
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Notification)
);
